import { observer } from "mobx-react-lite";
import React, { useLayoutEffect, useRef } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import _ from "lodash";
import { get_color } from "../../report-visuals";

am4core.useTheme(am4themes_animated);

export const StackBarChart = observer(({ data, label, type, chartId = "stack_bar_chart" }: any) => {
    const chartRef = useRef<am4charts.XYChart | null>(null);

    useLayoutEffect(() => {
        const chartData = _.orderBy(data, label, "desc");
        const chart = am4core.create(chartId, am4charts.XYChart);
        chart.hiddenState.properties.opacity = 0;
        chart.plotContainer.strokeWidth = 0;
        chart.data = chartData;

        const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = label;
        categoryAxis.renderer.grid.template.location = 0;

        const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;

        if (type === "100%stacked") {
            valueAxis.max = 100;
            valueAxis.strictMinMax = true;
            valueAxis.calculateTotals = true;
        }

        const createSeries = (field: string, name: string, color: string) => {
            const series = chart.series.push(new am4charts.ColumnSeries());
            series.name = name;
            series.dataFields.valueY = field;
            series.dataFields.categoryX = label;
            series.stacked = true;
            series.fill = am4core.color(color);
            series.columns.template.width = am4core.percent(75);
            series.columns.template.tooltipText = "[bold]{name}[/]: [bold]{valueY}";

            if (type === "100%stacked") {
                series.dataFields.valueYShow = "totalPercent";
            }
        };

        const allSeries = _.uniq(
            chartData.flatMap((row: any) => Object.keys(row).filter((key) => key !== "date"))
        );

        allSeries.forEach((field: string, index: number) => createSeries(field, field, get_color(index)));
        chart.legend = new am4charts.Legend();
        chartRef.current = chart;

        return () => {
            chart.dispose();
        };
    }, [data, label, type, chartId]);

    return <div id={chartId} className="flex h-screen w-full flex-col" />;
});
